/* 🌑 Chronophage — Coming Soon placeholder (Mar 2026)
 * ---------------------------------------------------
 * The Chronophage guild boss will run on its own dedicated economy
 * (owner note: "Chronophage Attack is different too"). Until the
 * mechanics are finalised, this page shows a lore-driven teaser card
 * so players know the fight is coming.
 */
import { Link } from "react-router-dom";

export default function ChronophageComingSoon() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#050505] via-[#0A0710] to-[#050505] text-neutral-100 flex items-center justify-center p-6">
      <div
        data-testid="chronophage-coming-soon"
        className="relative w-full max-w-2xl rounded-2xl border-2 p-8 md:p-10 overflow-hidden shadow-[0_0_60px_rgba(139,92,246,0.15)]"
        style={{
          borderColor: "#7C3AED55",
          background:
            "radial-gradient(circle at 30% 20%, rgba(124,58,237,0.15), transparent 55%), #0A0710",
        }}
      >
        {/* Ambient tick marks — clock imagery */}
        <div className="absolute inset-0 opacity-10 pointer-events-none"
             style={{ background:
               "repeating-linear-gradient(0deg, #7C3AED 0 1px, transparent 1px 40px)"}} />
        <div className="relative z-10 space-y-5">
          <div className="text-[10px] uppercase tracking-[0.35em] text-violet-300 font-black">
            Guild Boss · Reserved Slot
          </div>
          <div className="flex items-center gap-4">
            <div className="text-6xl leading-none drop-shadow-[0_0_20px_rgba(139,92,246,0.7)]">
              ⏳
            </div>
            <div>
              <h1 className="font-black text-4xl md:text-5xl tracking-wide text-violet-100"
                  style={{ fontFamily: "Anton, sans-serif" }}>
                Chronophage Attack
              </h1>
              <p className="text-sm text-violet-300/80 italic mt-1">
                The Devourer of Hours stirs...
              </p>
            </div>
          </div>

          <div className="border-t border-violet-900/50 pt-4 space-y-3 text-sm text-neutral-300 leading-relaxed">
            <p>
              Whole guilds have vanished into <span className="text-violet-300 font-bold">its unblinking hunger for time itself.</span>
              {" "}Every second a member fights it, the seconds cost more to earn back. Every clock in the encounter
              runs on rules the world outside doesn&apos;t agree with.
            </p>
            <p>
              The Chronophage Guild-Boss encounter is coming with its own economy — <span className="italic">separate from the standard Hall / Pool wealth rails</span> — 
              because a fight against a being that <em>eats time</em> can&apos;t be paid for in gold.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 pt-4 border-t border-violet-900/40">
            {[
              { icon: "⚔️", label: "Guild-wide raid"},
              { icon: "🕒", label: "Time-bank economy"},
              { icon: "💠", label: "Bespoke drop table"},
              { icon: "🏆", label: "Chronoform titles"},
            ].map((f) => (
              <div key={f.label}
                   className="text-center border border-violet-900/40 rounded-lg py-3 px-2 bg-black/40">
                <div className="text-2xl">{f.icon}</div>
                <div className="text-[10px] text-violet-200/80 mt-1 font-bold uppercase tracking-widest">
                  {f.label}
                </div>
              </div>
            ))}
          </div>

          <div className="pt-4 border-t border-violet-900/40 flex flex-wrap items-center justify-between gap-3">
            <div className="text-xs text-violet-300 font-bold uppercase tracking-widest">
              ⏳ COMING SOON
            </div>
            <Link
              data-testid="chronophage-back-to-guild"
              to="/guild"
              className="text-[11px] uppercase tracking-widest px-4 py-2 rounded-md border border-violet-600/60 text-violet-200 hover:bg-violet-600/20"
            >
              ← Back to Guild
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
